var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"date-tab"}},[_c('ul',_vm._l((_vm.dateList),function(item){return _c('li',{on:{"click":function($event){return _vm.selectDate(item)}}},[_c('a',{class:{ 'active' : item.isActive }},[_vm._v(_vm._s(_vm.$t(item.name)))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }